'use strict';

import { Utilities } from '../../Utilities/Utilities';
import { AutomationAction } from './AutomationAction';
import { Entity } from '../Entity';

export class AutomationSchedule extends Entity {
  protected id;
  protected scheduledDateTime;
  protected automationAction;
  protected data = null;
  protected processed;
  protected groupKey: string;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.processed = data.processed;
    this.groupKey = data.groupKey;

    if (data.scheduledDateTime) {
      const scheduledDateTime = Utilities.dateTimeStringToDateTime(data.scheduledDateTime);
      this.scheduledDateTime = scheduledDateTime;
    }

    if (data.automationAction) {
      const automationAction = new AutomationAction();
      automationAction.hydrate(data.automationAction);

      this.automationAction = automationAction;
    }

    this.data = data.data;
  }

  public getId() {
    return this.id;
  }

  public getScheduledDateTime() {
    return this.scheduledDateTime;
  }

  public setScheduledDateTime(scheduledDateTime: Date) {
    this.scheduledDateTime = scheduledDateTime;
    return this;
  }

  public getAutomationAction() {
    return this.automationAction;
  }

  public setAutomationAction(automationAction: AutomationAction) {
    this.automationAction = automationAction;
    return this;
  }

  public getData() {
    return this.data;
  }

  public setData(data: any) {
    this.data = data;
    return this;
  }

  public getGroupKey() {
    return this.groupKey;
  }

  public setGroupKey(groupKey: string) {
    this.groupKey = groupKey;
    return this;
  }

  public getProcessed() {
    return this.processed;
  }

  public setProcessed(processed: boolean) {
    this.processed = processed;
    return this;
  }
}
